// The person's own alert settings for one project: the read, and one write per
// change (optimistic, rolled back with a toast on failure).

import { useQuery } from '@tanstack/react-query';
import type { AlertSettingKey, IAlertSettingUpdate } from '@d-orca/shared/alert-kinds';
import { fetchPersonalAlertSettings, updatePersonalAlertSetting } from '@apis/alerts';
import { useOptimisticSettingUpdate } from '@components/AlertSettings/useOptimisticSettingUpdate';

const personalKey = (siteId: string) => ['alertSettings', 'me', siteId] as const;

export function usePersonalAlertSettings(siteId: string) {
  return useQuery({
    queryKey: personalKey(siteId),
    queryFn: () => fetchPersonalAlertSettings(siteId),
    refetchOnWindowFocus: false,
  });
}

export function useUpdatePersonalAlertSetting(siteId: string) {
  return useOptimisticSettingUpdate(personalKey(siteId), (key: AlertSettingKey, update: IAlertSettingUpdate) =>
    updatePersonalAlertSetting(siteId, key, update),
  );
}
